import {useState} from "react";
import StateCheckMobileSection from "@/pages/auth/_section/authCheckMobileSection";
import StateLoginSection from "@/pages/auth/_section/StateLoginSection";
import StateRegisterSection from "@/pages/auth/_section/StateRegisterSection";
import StateOtpSection from "@/pages/auth/_section/StateOtpSection";
import StateRecoverySection from "@/pages/auth/_section/StateRecoverySection";
import AuthLayout from "@/components/layout/auth/AuthLayout";
import QuranRazaviLogin from "@/pages/auth/QuranRzaviAUth/QuranRazaviLogin";

export function AuthMobileCheckPage() {

    const [myState, setMyState] = useState('check')
    const [myMobile, setMyMobile] = useState('')
    const [myData, setMyData] = useState({})

    // return (<QuranRazaviLogin />)
    return (<>
            <AuthLayout showSocialNetworks={myState === 'check'}>
                {myState === 'check' && (<StateCheckMobileSection
                    changeMyState={setMyState} state={myState}
                    setMyMobile={setMyMobile}
                    setMyData={setMyData}

                />)}

                {myState === 'login' && (<StateLoginSection
                    changeMyState={setMyState}
                    state={myState}
                    myMobile={myMobile}
                    setMyData={setMyData}
                />)}

                {myState === 'register' && (<StateRegisterSection
                    changeMyState={setMyState} state={myState}
                    myMobile={myMobile}
                    setMyMobile={setMyMobile}
                    setMyData={setMyData}
                />)}


                {myState === 'recovery' && (<StateRecoverySection
                    changeMyState={setMyState} state={myState}
                    myMobile={myMobile}
                    setMyMobile={setMyMobile}
                    setMyData={setMyData}
                />)}

                {myState === 'otp' && (<StateOtpSection
                    changeMyState={setMyState} state={myState}
                    myMobile={myMobile}
                    myData={myData}
                    setMyData={setMyData}
                    setMyMobile={setMyMobile}
                />)}
            </AuthLayout>
        </>
    )
}


